import React from 'react'
import styled from 'styled-components'

const AppStyled = styled.div`
font-family:sans-serif;
`;

const BoldLable = styled.label`
font-weight:bold;
`;

const Styl = () => {
  return (
    <AppStyled>
        <form action="">
            <div>
                <BoldLable>Username : </BoldLable>
                <input placeholder='enter username' />
            </div>
            <div>
                <BoldLable>Password : </BoldLable>
                <input type="password" placeholder='enter password' />
            </div>
        </form>
    </AppStyled>
  )
}

export default Styl